module.exports = __webpack_public_path__ + "img/RPD-RSONU-02_25-700.d6311f23.png";